module.exports = __webpack_public_path__ + "static/media/gc-kolonaki.b2a4aeb7.png";